const state = {
  template: {
    loading: false,
    panel_left: false,
    init_to_menu: false,
    header_display: true,
    label: "",
    app_class: "",
    header_type: "",
    myOrder: false
  },
  reloadIndexedDB: true,
  flatModalLanguageHomeMain: 0,
  isFirefox: typeof InstallTrigger !== 'undefined'
};

const getters = {

};

const actions = {
};

const mutations = {
  setFlatModalLenguage(state,data) {
    state.flatModalLanguageHomeMain = data
  },
  SetLoading(state, active) {
    state.template.loading = active;
  },
  SwitchLeftPanel(state) {
    state.template.panel_left = !state.template.panel_left;
  },
  OpenLeftPanel(state) {
    state.template.panel_left = true;
  },
  CloseLeftPanel(state) {
    state.template.panel_left = false;
  },
  SetInitToMenu(state, data) {
    state.template.init_to_menu = data;
  },
  //Activo el header del layout, y seteo el tipo de header "main", "internal"
  TemplateActiveHeader(state, data) {
    state.template.header_display = true;
    state.template.header_type = data.header_type;
    state.template.label = data.label;
    if(data.navigatorMyOrder) {
      state.template.navigatorMyOrder.tab1 = data.navigatorMyOrder.tab1;
      state.template.navigatorMyOrder.tab2 = data.navigatorMyOrder.tab2;
      state.template.navigatorMyOrder.tab3 = data.navigatorMyOrder.tab3;
    };
  },
  //Desactivo el header del layout
  TemplateDisableHeader(state) {
    state.template.header_display = false;
  },
  SetAppClass(state, data) {
    state.template.app_class = data;
  },
  SetReload(state, data) {
    state.reloadIndexedDB = data;
  },
  setisFirefox(state, data) {
    state.isFirefox = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
